import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

/**
 * Searchable category picker for the asset dialogs: an underline-styled
 * trigger opening a cmdk combobox. Rendered inside FullScreenModal
 * (z-[100]), hence the explicit z-[110] on the panel.
 */
export default function CategorySelect({ value, onChange, categories }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          role="combobox"
          aria-expanded={open}
          className="flex w-full items-center justify-between border-0 border-b-[1.5px] border-vaulzo-input-line bg-transparent py-2 text-left text-base text-vaulzo-ink outline-none transition-colors focus:border-vaulzo-accent"
        >
          <span className={value ? "" : "text-vaulzo-subtle"}>{value || "Select a category"}</span>
          <ChevronsUpDown className="h-4 w-4 text-vaulzo-fainter" strokeWidth={1.7} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="z-[110] w-[--radix-popover-trigger-width] rounded-[14px] border-vaulzo-hairline bg-vaulzo-surface p-0 shadow-[0_10px_30px_rgba(23,24,26,0.10)]"
      >
        <Command>
          <CommandInput placeholder="Search category…" />
          <CommandList className="max-h-[260px]">
            <CommandEmpty>No category found.</CommandEmpty>
            <CommandGroup>
              {categories.map((c) => (
                <CommandItem
                  key={c}
                  value={c}
                  onSelect={() => {
                    onChange(c);
                    setOpen(false);
                  }}
                  className="cursor-pointer text-vaulzo-ink aria-selected:bg-vaulzo-row"
                >
                  <Check
                    className={`mr-2 h-4 w-4 text-vaulzo-accent ${value === c ? "opacity-100" : "opacity-0"}`}
                    strokeWidth={2}
                  />
                  {c}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
